import { AgGridReact } from 'ag-grid-react';

/**
 * Default grid print for the print icon in the ComposedViewAgGrid.
 */
const printGrid = (grid: AgGridReact) => {
  const originalDOMLayout = grid.props.domLayout;
  grid.api.setDomLayout('print');
  // Yes this setTimeout is on purpose. The docs say this is how this should be done:
  // https://ag-grid.com/react-data-grid/printing/#example-for-print-complex
  setTimeout(() => {
    window.print();
    grid.api.setDomLayout(originalDOMLayout);
  }, 2000);
};

export default printGrid;
